import { IGetAllSubcontasUseCase } from "../../../presentation/useCases/read/get_all_subcontas_use_case";
import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";
import { Subconta } from "../../models/subconta";
import { SubcontaLista } from "../../models/subconta_lista";

/**
 * GetAllSubcontasUseCase
 */

export class GetAllSubcontasUseCase extends BasePaginatedUseCase<SubcontaLista> implements IGetAllSubcontasUseCase {
  constructor(private readonly repository: IComercialRepository) {
    super();
  }

  async execute(
    codigo?: string,
    descricao?: string,
    status?: number,
    currentPage?: number,
    rowsPerPage?: number)
    : Promise<void> {
    const result = await this.repository.getAllSubcontas(
      codigo,
      descricao,
      status,
      currentPage,
      rowsPerPage
    );

    this._items = result.items;
    this._currentPage = result.currentPage;
    this._pageSize = result.pageSize;
    this._totalItems = result.totalItems;
    this._totalPages = result.totalPages;

  }
}
